var app = app ? app : {};
$(function() {
	app.dataList = {
		vars: {
			masonry: null,
			node: $('.js-list').data('node'),
			endpoint: $('.js-list').data('endpoint'),
			start: $('.js-list').data('start'),
			pageSize: $('.js-list').data('pagesize') ? $('.js-list').data('pagesize') : 10,
		},
		el: {
			main: $('.js-list'),
			filtersForm: $('.js-list .js-filter-form'),
			listContainer: $('.js-list .js-container'),
			loadMore: $('.js-list .js-load-more')
		},
		loadContainer: function() {
			var self = this;
			var params = self.el.filtersForm.serialize();
			params += '&start=' + self.vars.start;
			params += '&pageSize=' + self.vars.pageSize;
			if (self.vars.node)
				params += '&nodeid=' + self.vars.node;

			console.log(params);

			self.el.loadMore.addClass('loading');
			$.get(self.vars.endpoint, params, function(data, m, e) {
				var elems = $(data);
				if (self.vars.start == 0) {
					self.el.listContainer.html(data);
					self.vars.masonry.masonry('reloadItems');
				}
				else {
					self.vars.masonry.append(elems).masonry('appended', elems);
				}

				if (self.vars.masonry) {
					$('.js-list .js-container').imagesLoaded(function() {
						self.vars.masonry.masonry('layout');
					});
				}

				self.el.loadMore.removeClass('loading');
				if (e.status == 200) {
					self.el.loadMore.hide();
				}
				else if (e.status == 202) {
					self.el.loadMore.show();
					self.vars.start += self.vars.pageSize;
					$(self.el.main).data('start', self.vars.start);
				}
			});
		},
		init: function() {
			var self = this;
			if ($(self.el.listContainer).length) {
				self.vars.masonry = $('.js-list .js-container').masonry();

				$('.js-list .js-container').imagesLoaded(function() {
					self.vars.masonry.masonry('layout');
				});

			}

			self.el.filtersForm.off('change').change(function() {
				self.vars.start = 0;
				$(self.el.main).data('start', self.vars.start);
				self.loadContainer();
			});


			self.el.loadMore.off('click').click(function() {
				$(".js-load-more > span:first-child").addClass("button");
				$(".js-load-more .button").addClass("btn-loading");
				$(".js-load-more .btn-loading .icon-closeicon").addClass("btn-loading-spinner");
				$(".js-load-more .btn-loading .btn-loading-spinner").removeClass("icon-closeicon");
				setTimeout(function() {
					self.loadContainer();
					$(".js-load-more > span:first-child").removeClass("button btn-loading");
					$(".js-load-more > span:first-child span").addClass("icon-closeicon");
					$(".js-load-more > span:first-child span").removeClass("btn-loading-spinner");
				}, 2000);
			});


		}

	}

	app.dataList.init();
});